import React from "react";
import "./Card.css";

const Card = (props) => {
  return <div className="cardnew">{props.children}</div>;
};

export default Card;
